var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 31444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 5H2C1.44867 5 1 4.55133 1 4V2C1 1.44867 1.44867 1 2 1H16C16.5513 1 17 1.44867 17 2V4C17 4.55133 16.5513 5 16 5ZM2 1.66667C1.816 1.66667 1.66667 1.816 1.66667 2V4C1.66667 4.184 1.816 4.33333 2 4.33333H16C16.184 4.33333 16.3333 4.184 16.3333 4V2C16.3333 1.816 16.184 1.66667 16 1.66667H2Z",
    fill: "#535763",
    stroke: "#535763",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.33333 16.9999H2C1.44867 16.9999 1 16.5513 1 15.9999V7.33325C1 6.78192 1.44867 6.33325 2 6.33325H7.33333C7.88467 6.33325 8.33333 6.78192 8.33333 7.33325V15.9999C8.33333 16.5513 7.88467 16.9999 7.33333 16.9999ZM2 6.99992C1.816 6.99992 1.66667 7.14925 1.66667 7.33325V15.9999C1.66667 16.1839 1.816 16.3333 2 16.3333H7.33333C7.51733 16.3333 7.66667 16.1839 7.66667 15.9999V7.33325C7.66667 7.14925 7.51733 6.99992 7.33333 6.99992H2Z",
    fill: "#535763",
    stroke: "#535763",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0003 10.9999H10.667C10.1157 10.9999 9.66699 10.5513 9.66699 9.99992V7.33325C9.66699 6.78192 10.1157 6.33325 10.667 6.33325H16.0003C16.5517 6.33325 17.0003 6.78192 17.0003 7.33325V9.99992C17.0003 10.5513 16.5517 10.9999 16.0003 10.9999ZM10.667 6.99992C10.483 6.99992 10.3337 7.14925 10.3337 7.33325V9.99992C10.3337 10.1839 10.483 10.3333 10.667 10.3333H16.0003C16.1843 10.3333 16.3337 10.1839 16.3337 9.99992V7.33325C16.3337 7.14925 16.1843 6.99992 16.0003 6.99992H10.667Z",
    fill: "#535763",
    stroke: "#535763",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0003 16.9999H10.667C10.1157 16.9999 9.66699 16.5513 9.66699 15.9999V13.3333C9.66699 12.7819 10.1157 12.3333 10.667 12.3333H16.0003C16.5517 12.3333 17.0003 12.7819 17.0003 13.3333V15.9999C17.0003 16.5513 16.5517 16.9999 16.0003 16.9999ZM10.667 12.9999C10.483 12.9999 10.3337 13.1493 10.3337 13.3333V15.9999C10.3337 16.1839 10.483 16.3333 10.667 16.3333H16.0003C16.1843 16.3333 16.3337 16.1839 16.3337 15.9999V13.3333C16.3337 13.1493 16.1843 12.9999 16.0003 12.9999H10.667Z",
    fill: "#535763",
    stroke: "#535763",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPJobs);
export default __webpack_public_path__ + "static/media/pJobs.9c195a342b40bdc1fc4303a038812f94.svg";
export { ForwardRef as ReactComponent };